import { type FC } from 'react'
import pluralize from 'pluralize'
import { Link } from 'react-router-dom'
import { FormFeedback } from '../../../components/Form/FormFeedback'
import { RoleType } from '../../../models/Role'
import { type SeatPurchase } from '../../../store/auth/auth'
import { seatTypeLabels } from '../roleChangeSeatImpact'
import { SeatPurchaseSummary } from '../SeatPurchaseSummary'
import { type SeatPurchasePreview } from '../useSeatPurchasePreview'

export interface BulkInvitePurchaseStepProps {
  purchase: SeatPurchase
  invitationCount: number
  preview: SeatPurchasePreview
  error: string | null
}

const seatPhrase = (count: number, seatType: RoleType) => `${count} ${seatTypeLabels[seatType]} ${pluralize('seat', count)}`

const purchasePhrase = (purchase: SeatPurchase) =>
  [purchase.general > 0 ? seatPhrase(purchase.general, RoleType.SEAT) : null, purchase.sidecar > 0 ? seatPhrase(purchase.sidecar, RoleType.SIDECAR) : null]
    .filter(Boolean)
    .join(' and ')

export const BulkInvitePurchaseStep: FC<BulkInvitePurchaseStepProps> = ({ purchase, invitationCount, preview, error }) => (
  <div className='d-flex flex-column gap-3'>
    <div className='paragraph-medium'>
      You&apos;re about to buy {purchasePhrase(purchase)} for {invitationCount} requested {pluralize('invitation', invitationCount)}.
      <br />
      {invitationCount === 1
        ? 'Once the seat is purchased, we will send the invitation email. If you cancel, we will save this invitation to the requested list.'
        : 'Once the seats are purchased, we will send the invitation emails. If you cancel, we will save these invitations to the requested list.'}
    </div>
    <SeatPurchaseSummary preview={preview} />
    <div className='paragraph-small zocks-text-gray-600'>
      You can also manage your seats on the <Link to='/account/plan'>Plan page</Link>.
    </div>
    {error ? <FormFeedback>{error}</FormFeedback> : null}
  </div>
)
